import { reactive } from 'vue';

const state = reactive({
    type: 'alert',
    active: false,
    message: '',
    message2: '',
    message3: '',
    detail: false,
    title: '',
    okText: '확인',
    cancelText: '취소',
    inputType: 'text',
    html: false,
    error: false,
    customCancelButton: '',
    customConfirmButton: '확인',
});

// -----------------------------------
// Private Methods
// -----------------------------------
let close: any; // will hold our promise resolve function
const dialogPromise = () => new Promise((resolve) => (close = resolve));
const open = (message: string, message2?: string, message3?: string, customCancelButton?: string, customConfirmButton?: string) => {
    state.message = message;
    state.message2 = message2 ?? '';
    state.message3 = message3 ?? '';
    state.customCancelButton = customCancelButton ?? '';
    state.customConfirmButton = customConfirmButton ?? '확인';
    state.active = true;
    return dialogPromise();
};

const reset = () => {
    state.active = false;
    state.message = '';
    state.message2 = '';
    state.message3 = '';
    state.detail = false;
    state.okText = '확인';
    state.cancelText = '취소';
    state.inputType = 'text';
    state.html = false;
    state.title = '';
    state.type = 'alert';
    state.customCancelButton = '';
    state.customConfirmButton = '확인';
};

// -----------------------------------
// Public interface
// -----------------------------------

const dialog = {
    get state() {
        return state;
    },
    title(title: string) {
        state.title = title;
        return this;
    },
    okText(text: string) {
        state.okText = text;
        return this;
    },
    cancelText(text: string) {
        state.cancelText = text;
        return this;
    },
    inputType(type: string) {
        state.inputType = type;
        return this;
    },
    html(enabled = true) {
        state.html = enabled;
        return this;
    },
    error(message: string, message2?: string) {
        state.type = 'error';
        return open(message, message2);
    },
    alert(message: string, message2?: string) {
        state.type = 'alert';
        return open(message, message2);
    },
    popup(message: string, message2?: string) {
        state.type = 'popup';
        return open(message, message2);
    },
    confirm(message: string, message2?: string) {
        state.type = 'confirm';
        return open(message, message2);
    },
    custom(message: string, message2?: string, message3?: string, customCancelButton?: string, customConfirmButton?: string) {
        state.type = 'custom';
        return open(message, message2, message3, customCancelButton, customConfirmButton);
    },
    prompt(message: string, message2?: string) {
        state.type = 'prompt';
        return open(message, message2);
    },
    detail(message: string) {
        state.type = 'detail';
        return open(message)
    },
    cancel() {
        close(false);
        state.error = false;
        reset();
    },
    ok(input = true) {
        input = state.type === 'prompt' ? input : true;
        state.error = false;
        close(input);
        reset();
    },
};

export default dialog;